import * as ProgressPrimitive from '@radix-ui/react-progress';
import { forwardRef, HTMLAttributes } from 'react';

import { cn } from '../utils';

type ProgressProps = HTMLAttributes<HTMLDivElement> & {
  value?: number;
  max?: number;
};

export const Progress = forwardRef<HTMLDivElement, ProgressProps>(
  ({ className, value = 0, max = 100, ...props }, ref) => (
    <ProgressPrimitive.Root
      ref={ref}
      className={cn('relative h-2 w-full overflow-hidden rounded-full', className)}
      {...props}
    >
      <ProgressPrimitive.Indicator
        className='h-full w-full flex-1 transition-all bg-primary-100'
        style={{
          transform: `translateX(-${100 - (value / max) * 100}%)`,
        }}
      />
    </ProgressPrimitive.Root>
  ),
);

Progress.displayName = 'Progress';
